<template>
    <button :type="type" class="btn" :class="[color, size]" :disabled="disabled">
        <i class="bi" :class="icon"></i>
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'ButtonExec',
    props: {
        text: {
            type: String,
            default: '実行',
        },
        icon: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'button',
        },
        color: {
            type: String,
            default: 'btn-outline-primary'
        },
        size: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
